var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-layout',{attrs:{"layout":['xs12']}},[_c('l-data-table',{attrs:{"get-data-func":_vm.getBachelors,"headers":_vm.headers,"must-sort":false,"clickable":"","item-key":"code","search-text":"搜索姓名","title-text":"本科生列表","filter-items":_vm.filterItems},on:{"click:row":function($event){return _vm.goDetails($event.item)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }